import styled from 'styled-components';

export const StyledForgotForm = styled.div`
  width: 100%;

  .forgot-form {
    width: 100%;
    justify-content: center;

    &__item {
    }

    &__submit {
      margin-top: 40px;

      button {
        width: 100%;
      }
    }

    &__social {
      margin-top: 32px;
    }

    &__divider {
      display: flex;
      align-items: center;
      gap: 16px;
      margin-bottom: 24px;
    }

    &__divider-line {
      flex: 1;
      height: 1px;
      background-color: #e0e0e0;
    }

    &__divider-text {
      color: #999;
      font-size: 14px;
      font-weight: 500;
      text-transform: lowercase;
    }

    &__social-buttons {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 20px;
    }
  }
`;
